export {default} from './onboarding.vue'